import React, { FC, useState } from 'react';

import PathwayLessonVm from '../models/LessonVm';

interface LessonCardComponentProps {
  lesson: PathwayLessonVm;
  filteredByStatus: boolean;
  onLaunchPathwayLesson: (
    lessonWindow: Window,
    title: string,
    resultkey: string
  ) => void;
}
interface WithPathwayLessonLaunchProps {
  lesson: PathwayLessonVm;
  filteredByStatus?: boolean; // * optional, for pathway list only
  onLaunchPathwayLesson: (
    lessonWindow: Window,
    title: string,
    zonekey: number,
    pathkey: string,
    lessonkey: string,
    resultkey: string
  ) => void;
  LessonCardComponent: FC<LessonCardComponentProps>;
}

const WithPathwayLessonLaunch = (props: WithPathwayLessonLaunchProps) => {
  const { LessonCardComponent, lesson } = props;
  const [showZoneDialog, setShowZoneDialog] = useState(false);

  const onLaunchLesson = (
    lessonWindow: Window,
    title: string,
    resultkey: string
  ) => {
    const distributionZone = lesson.zones.find(
      (zone) => zone.isDistributionZone
    );
    if (lesson.zones.length > 1 && !distributionZone) {
      setShowZoneDialog(true);
    } else {
      const { pathkey, lessonkey } = lesson;
      const zone = distributionZone || lesson.zones[0];
      props.onLaunchPathwayLesson(
        lessonWindow,
        title,
        zone.zonekey,
        pathkey,
        lessonkey,
        resultkey
      );
    }
  };

  return (
    <LessonCardComponent
      lesson={lesson}
      filteredByStatus={props.filteredByStatus}
      onLaunchPathwayLesson={onLaunchLesson}
    />
  );
};

export default WithPathwayLessonLaunch;
